import Request from './request';
import consts from "@/consts.js";

async function fetch(data) {
  return Request('get', "api/balance-categories", data);
}

async function fetchAll(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; //获取全部
  return Request('get', "api/balance-categories", data, false, false, true);
}

async function del(id){
  return Request('delete',"api/balance-categories/delete/" + id )
}

async function save(id, data) {// 编辑或新建数据（有id为编辑，没有id为新建）
  if (id) {
      return Request('patch', "api/balance-categories/edit?id=" + id, data);
  } else {
      return Request('post', "api/balance-categories/add", data);
  }
}
export default {
  fetch,
  fetchAll,
  del,
  save
}